import TeamLookupMenu, { IUserSearchState as Temp } from './TeamLookupMenu';

export interface IUserSearchState extends Temp { }
export default TeamLookupMenu;
